<template>
  <a-modal
    title="新建客户"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-col :span="12">
            <a-form-item label="名称">
              <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="分类" >
              <a-select
                v-decorator="[
                  'types',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                allow-clear
                mode="multiple"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_client_types">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="国家/地区" >
              <a-select
                v-decorator="[
                  'country',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.country">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="英文名称">
              <a-input v-decorator="['en_name', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="税号">
              <a-input v-decorator="['unique_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="营业执照号">
              <a-input v-decorator="['business_license_number', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="统一社会信用代码">
              <a-input v-decorator="['unified_social_credit_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="注册地址">
              <a-input v-decorator="['registered_address', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="注册资本">
              <a-input-number style="width: 50%" v-decorator="['registered_capital', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="法人">
              <a-input v-decorator="['legal_representative', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="联系人">
              <a-input v-decorator="['contact', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="电话">
              <a-input v-decorator="['phone', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="邮箱">
              <a-input v-decorator="['mail', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="传真">
              <a-input v-decorator="['fax', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="金蝶编码">
              <a-input v-decorator="['jd_code', {rules: [{required: false, message: '必填项，请填写信息'}, {max:16, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'

// 表单字段
const fields = ['id', 'name', 'code']
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    return {
      color: '#3f3f3f',
      form: this.$form.createForm(this),
      code: ''
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>
